<template>
  <SidebarLayout>
    <template #aside>
      <FeedSidebar />
    </template>

    <template #banner>
      <div v-if="$slots.banner">
        <slot name="banner" />
      </div>
    </template>
    <slot />
    <template #dynamicContent>
      <RouterView v-slot="{ Component }" name="dynamicContent">
        <component :is="Component" />
      </RouterView>
    </template>
  </SidebarLayout>
</template>

<script setup lang="ts">
import FeedSidebar from "@/components/archive/FeedSidebar/FeedSidebar.vue";
import SidebarLayout from "@/layouts/SidebarLayout.vue";
import { useSearchStore } from "@/stores/search.ts";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- needed to have saved searches working
const searchStore = useSearchStore();
</script>
